<div class="wrapperOnboarding"
     [stepContent]="searchSavePopupContent"
     [joyrideStep]="'searchSavePopupStep'"
     (prev)="onNoClick()"
     (next)="onNoClick()">

    <div class="fs-2 with-close" mat-dialog-title>
        Sauvegarder votre recherche
        <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
    </div>
    <div mat-dialog-content>
        <form (ngSubmit)="onYesClick()" [formGroup]="favoriteForm">
            <mat-form-field class="mt-3 pb-0">
                <mat-label>Nom</mat-label>
                <input formControlName="title" matInput class="text">
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions>
        <button type="button" (click)="onNoClick()" type="reset" class="btn btn-outline">
            Annuler
        </button>
        <button (click)="onYesClick()" type="submit" class="btn btn-primary">
            <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
            <ng-container *ngIf="!loading">Enregistrer</ng-container>
        </button>
    </div>
</div>

<!-- Onboarding -->
<ng-template #searchSavePopupContent>
    <div class="user_onboarding_content">
        <h2>Enregistrer votre recherche</h2>
        <p>
            Vous pouvez remplacer une recherche existante ou bien en créer une nouvelle en lui donnant un nom.
        </p>
    </div>
</ng-template>
